module.exports = __webpack_public_path__ + "static/media/catarina_castro.1b462da3.jpg";